import React from "react";
import HomeMiddleBanners from "../components/HomeMiddleBanners";
import { t } from "../../../helpers";
import { PHOTOS_URL } from "../../../constants";
import { Link } from "react-router-dom";

type ImStatelessProps = {
  lang: string;
  country: string;
};

const Categories = React.memo<ImStatelessProps>((props) => {
  const QUIZ_URL = `/${props.lang}-${props.country}/quizz/1/`;
  return (
    <div className="categoriesMenu">
      <div className="categoryInner">
        <Link to={`${QUIZ_URL}`}>
          <div className="categoryImg">
            <img
              src={`https://resizing.cocunat.com/r/?fit=contain&image=${PHOTOS_URL}faceCat.png&quality=95`}
              alt="Face"
              height={117}
              width={115}
            />
          </div>
          <div className="categoryText">
            <p
              dangerouslySetInnerHTML={{
                __html: t("faceLine"),
              }}
            />
          </div>
        </Link>
      </div>
      <div className="categoryInner">
        <Link to={`${QUIZ_URL}`}>
          <div className="categoryImg">
            <img
              src={`https://resizing.cocunat.com/r/?fit=contain&image=${PHOTOS_URL}bodyCat.png&quality=95`}
              alt="Body"
              height={117}
              width={115}
            />
          </div>
          <div className="categoryText">
            <p
              dangerouslySetInnerHTML={{
                __html: t("bodyLine"),
              }}
            />
          </div>
        </Link>
      </div>
      <div className="categoryInner">
        <Link to={`${QUIZ_URL}`}>
          <div className="categoryImg">
            <img
              src={`https://resizing.cocunat.com/r/?fit=contain&image=${PHOTOS_URL}hairCat.png&quality=95`}
              alt="Hair"
              height={117}
              width={115}
            />
          </div>
          <div className="categoryText">
            <p
              dangerouslySetInnerHTML={{
                __html: t("hairLine"),
              }}
            />
          </div>
        </Link>
      </div>
      <div className="categoryInner">
        <Link to={`${QUIZ_URL}`}>
          <div className="categoryImg">
            <img
              src={`https://resizing.cocunat.com/r/?fit=contain&image=${PHOTOS_URL}cnmuCat.png&quality=95`}
              alt="CNMU"
              height={117}
              width={115}
            />
          </div>
          <div className="categoryText">
            <p
              dangerouslySetInnerHTML={{
                __html: t("cnmuLine"),
              }}
            />
          </div>
        </Link>
      </div>
    </div>
  );
});
export default Categories;
